import styled from 'styled-components';

export const Root = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	max-width: 760px;
	padding: 32px;
	background: #fff;
	border-radius: 8px;
	box-sizing: border-box;
	overflow-y: auto;

	@media (max-width: 768px) {
		padding: 15px;
	}

	@media (max-width: 600px) {
		border-radius: 0;
		height: 100%;
	}
`;

export const ModalTitle = styled.p`
	margin: 0 0 24px;
	padding: 0;
	color: #000;
	${({ theme }) => theme.typography.textXL};
`;

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
`;

export const ContentText = styled.p`
	padding: 0;
	margin: 0;
	${({ theme }) => theme.typography.textL};
`;

export const ContentChips = styled.ul`
	display: flex;
	flex-wrap: wrap;
	padding: 0;
	margin: 0;
	gap: 6px 12px;

	li {
		display: block;
		margin: 0;
		padding: 9px 16px;
		border-radius: 20px;
		background: ${({ theme }) => theme.grayColor};
		${({ theme }) => theme.typography.textS};
	}
`;

export const PhonesWrapper = styled.div`
	margin: 32px 0;
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
	gap: 8px;
`;

export const Phone = styled.a`
	display: flex;
	max-width: 340px;
	flex-wrap: nowrap;
	gap: 12px;
	align-items: center;
	justify-content: center;
	padding: 12px 24px;
	border: ${({ theme }) => `1px solid ${theme.middleGrayColor}`};
	border-radius: 4px;
	color: ${({ theme }) => theme.primaryColor};
	white-space: nowrap;
	text-decoration: none;
	${({ theme }) => theme.typography.textXL};

	&:hover {
		background-color: ${({ theme }) => theme.grayColor};
		color: ${({ theme }) => theme.primaryHover};
	}

	svg {
		width: 24px;
		height: 24px;
		fill: ${({ theme }) => theme.secondaryHover};
	}
`;

export const NoPhone = styled.div`
	display: flex;
	max-width: 340px;
	flex-wrap: nowrap;
	gap: 12px;
	align-items: center;
	justify-content: center;
	padding: 12px 24px;
	border: ${({ theme }) => `1px solid ${theme.middleGrayColor}`};
	border-radius: 4px;
	color: ${({ theme }) => theme.darkGrayColor};
	white-space: nowrap;
	text-decoration: none;
	${({ theme }) => theme.typography.textXL};
`;

export const LivingBanner = styled.div`
	display: flex;
	gap: 24px;
	width: 100%;
	padding: 24px 28px;
	box-sizing: border-box;
	background: linear-gradient(180deg, #e2eaff 0%, #eeeffd 100%), #fff;
	border-radius: 8px;

	@media (max-width: 768px) {
		padding: 24px 16px;
	}
`;

export const LivingBannerContent = styled.div`
	display: flex;
	flex-direction: column;
`;

export const LivingBannerTitle = styled.p`
	padding: 0;
	margin: 0 0 12px;
	color: #000;
	${({ theme }) => theme.typography.textBoldL};
`;

export const LivingBannerText = styled.p`
	padding: 0;
	margin: 0 0 12px;
	color: #000;
`;

export const LivingBannerList = styled.ul`
	margin: 0 0 16px;
	font-weight: 500;
	color: #000;
`;

export const LivingBannerButton = styled.div`
	margin: 0 0 32px;

	@media (max-width: 480px) {
		& > * {
			width: 100%;
		}
	}
`;

export const LivingBannerImage = styled.figure`
	width: 208px;
	height: 255px;
	margin: 0 0 -24px;
	align-self: flex-end;
	flex-shrink: 0;

	@media (max-width: 768px) {
		display: none;
	}
`;

export const LoaderWrapper = styled.div`
	display: flex;
	width: 100%;
	min-width: 320px;
	min-height: 320px;
	align-items: center;
	justify-content: center;
`;
